import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import {
  type ArenaOffersName,
  type ArenaPackRewardDto,
  type BoxReward,
} from '@/common/types/shop/marketBoxes';
import { type ArenaOfferInfo } from '@/components/OffersMarket/ArenaOffers/config';
import RewardArray from '@/components/OffersMarket/ArenaOffers/RewardArray';
import { H1, H2, StringSmall } from '@/components/Typography/Typography';

interface ProductTitleDefaultProps {
  info: ArenaOfferInfo;
  name: ArenaOffersName;
  reward: BoxReward | ArenaPackRewardDto;
}

const ProductTitleDefault: FC<ProductTitleDefaultProps> = ({
  info,
  name,
  reward,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <H1>{t('Purchase')}</H1>
      <div className="text-center">
        <H2 className="mb-[4px]">{t(info.title)}</H2>
        <StringSmall
          className={cn({
            '!text-[#b8ffb6]': info.color === 'green',
            '!text-[#fffdb6]': info.color === 'yellow',
            '!text-[#ffb6b6]': info.color === 'red',
            '!text-[#E7D7FF]': info.color === 'purple',
          })}
        >
          {t(info.describe)}
        </StringSmall>
      </div>
      <RewardArray
        variant="big"
        name={name}
        reward={reward}
        classNames="items-center"
      />
    </>
  );
};

export default ProductTitleDefault;
